import { Button, Col, Row } from 'react-bootstrap'
import { connect } from 'react-redux'
import { VzPageContainer } from '../../../layouts/VzPageContainer'
import { GetExportReport } from './ExportReportActions'
import { useState } from 'react'
import FormikControl from '../../../layouts/Input/FormikControl'
import { Formik, Form } from 'formik'

const ExportReport = (props) => {

    const [isSubmit, setIsSubmit] = useState(false);

    const [filter, setfilter] = useState({
        reportName: null,
    })

    const reportColumns = [
        {
            label: 'Vizshops Username Password',
            value: 'VizshopsUsernamePassword',
        },
        {
            label: 'Vizshops Data',
            value: 'VizshopsData',
        },
        {
            label: 'CreditBook Loan Data',
            value: 'CreditBookLoanData',
        },
        {
            label: 'CreditBook KYC Summary Table',
            value: 'CreditBookKYCSummaryTable',
        },
        {
            label: 'CreditBook Loan Summary Table',
            value: 'CreditBookLoanSummaryTable',
        },
        {
            label: 'CreditBook Reconcillation Sheet',
            value: 'CreditBookReconcillationSheet',
        },
        {
            label: 'CreditBook KYC Shops Data',
            value: 'CreditBookKYCShopsData',
        },
        {
            label: 'Overdue Amount Report',
            value: 'OverdueAmountReport',
        },
        {
            label: 'Orders Data Report',
            value: 'OrdersDataReport',
        },
        {
            label: 'Payment Data Report',
            value: 'PaymentDataReport',
        },
        {
            label: 'VFO Visit Report',
            value: 'VFOVisitReport',
        }
    ]

    function formRequestObject() {
        let requestData = {
            reportName: filter.reportName?.value
        }
        return requestData
    }

    function getReportData() {
        setIsSubmit(true);
        props.GetExportReport(formRequestObject());
    }

    return (
        <div>
            <VzPageContainer title='Export Report'>
                <Row>
                    <Col style={{ float: 'left' }}>
                        <h4>
                            <b>Export Report</b>
                        </h4>
                        <br />
                    </Col>
                </Row>
                <Row>
                    <Formik
                        enableReinitialize
                        initialValues={filter}
                        onSubmit={() => getReportData()}
                    >
                        {(formik) => (
                            <Form autoComplete='off'>
                                <Row className='d-flex justify-content-center'>
                                    <Col xs={6} md={6}>
                                        <FormikControl
                                            formik={formik}
                                            control='react-select'
                                            label='Report'
                                            name='reportName'
                                            options={reportColumns}
                                            isClearable={true}
                                            handleOnChange={(option) => {
                                                setIsSubmit(false);
                                                filter.reportName = option
                                            }}
                                            value={filter.reportName}
                                        />
                                    </Col>
                                </Row>
                                <Row className='d-flex justify-content-center'>
                                    <Col xs={6} md={6} className='d-flex justify-content-center mt-5'>
                                        <Button
                                            type='submit'
                                            className='btn'
                                            disabled={filter.reportName == null || isSubmit}
                                        >
                                            Export To Excel
                                        </Button>
                                    </Col>
                                </Row>
                            </Form>
                        )}
                    </Formik>
                </Row>
            </VzPageContainer>
        </div >
    )
}

const mapStateToProps = (state) => {
    return {
    }
}
export default connect(mapStateToProps, {
    GetExportReport,
})(ExportReport)
